import BaseUseCase from "../../base_use_case.js.jsx";

class LoadInvestmentsListUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/investments`,
      params: params
    }).then((result) => {
      return result
    })
  }
}

const instance = new LoadInvestmentsListUseCase();
export default instance;